var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.27273C7.42135 7.27273 6.86639 7.5026 6.45722 7.91177C6.04805 8.32094 5.81818 8.87589 5.81818 9.45455C5.81818 10.0332 6.04805 10.5882 6.45722 10.9973C6.86639 11.4065 7.42135 11.6364 8 11.6364C8.57865 11.6364 9.13361 11.4065 9.54278 10.9973C9.95195 10.5882 10.1818 10.0332 10.1818 9.45455C10.1818 8.87589 9.95195 8.32094 9.54278 7.91177C9.13361 7.5026 8.57865 7.27273 8 7.27273ZM8 13.0909C7.03558 13.0909 6.11065 12.7078 5.4287 12.0258C4.74675 11.3439 4.36364 10.419 4.36364 9.45455C4.36364 8.49012 4.74675 7.5652 5.4287 6.88325C6.11065 6.2013 7.03558 5.81818 8 5.81818C8.96442 5.81818 9.88935 6.2013 10.5713 6.88325C11.2532 7.5652 11.6364 8.49012 11.6364 9.45455C11.6364 10.419 11.2532 11.3439 10.5713 12.0258C9.88935 12.7078 8.96442 13.0909 8 13.0909ZM8 4C4.36364 4 1.25818 6.26182 0 9.45455C1.25818 12.6473 4.36364 14.9091 8 14.9091C11.6364 14.9091 14.7418 12.6473 16 9.45455C14.7418 6.26182 11.6364 4 8 4Z",
    fill: "#939AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassShow);
export default __webpack_public_path__ + "static/media/passShow.3ad98b6c792736c7ebde84cf9243be7f.svg";
export { ForwardRef as ReactComponent };